interface MergerAcquisitionOrganization {
    organizationId?: string;
    organizationName: string;
}

export enum GeneralTransactionType {
    Investment = "Investment",
    MergerAcquisition = "M&A",
}

export interface MergerAcquisition {
    acquirerCountry?: string;
    acquirerRegion?: string;
    announceDate: Date;
    enterpriseValue?: string;
    generalTransactionType?: string;
    investmentAmount?: string;
    investorGeneralSectorCategory?: string;
    investors?: string[];
    mergerAcquisitionId: string;
    notes?: string;
    targetOrganization: MergerAcquisitionOrganization;
    acquirerOrganization: MergerAcquisitionOrganization;
    sourceLink?: string;
    status?: string;
    targetCountry?: string;
    targetGeneralSectorCategory?: string;
    targetProfile?: string;
    targetRegion?: string;
    trailingEbitda?: string;
    trailingRev?: string;
    transactionCurrency?: string;
    transactionEnterpriseValue?: string;
    transactionSubtype?: string;
}
